export default __webpack_public_path__ + "static/media/img-cube2.41664737.svg";